import { apiFloristGatewayService } from './apiService/HttpService';
import { setEndPoint } from './apiService/SetEndPoint';
import { endPoints } from './apiService/EndPoints';

/**
 * Preparation tasks - one task per cart line, driven entirely by the server: every
 * response carries the whole list back, including which buttons are allowed.
 */
class PreparationTasksService {
  static getTasks(orderId) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.preparationTasks, orderId),
      params: { includeActions: true },
    });
  }

  static startTask(orderId, taskId) {
    return apiFloristGatewayService({
      method: 'POST',
      url: setEndPoint(endPoints.preparationTaskAction, orderId, taskId, 'start'),
    });
  }

  static pauseTask(orderId, taskId, pauseReasonId) {
    return apiFloristGatewayService({
      method: 'POST',
      url: setEndPoint(endPoints.preparationTaskAction, orderId, taskId, 'pause'),
      data: { pauseReasonId },
    });
  }

  static resumeTask(orderId, taskId) {
    return apiFloristGatewayService({
      method: 'POST',
      url: setEndPoint(endPoints.preparationTaskAction, orderId, taskId, 'resume'),
    });
  }

  static finishTask(orderId, taskId) {
    return apiFloristGatewayService({
      method: 'POST',
      url: setEndPoint(endPoints.preparationTaskAction, orderId, taskId, 'finish'),
    });
  }

  static getHistory(orderId, params) {
    return apiFloristGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.preparationTasksHistory, orderId),
      params,
    });
  }
}

export default PreparationTasksService;
